"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalService = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const core_1 = require("@integro/core");
const log = (0, debug_1.default)('itp:ui:components:modal:modal-service');
const isError = (error) => {
    return error instanceof Error || (error && error.stack && error.message);
};
class ModalService {
    owner;
    manager;
    constructor(owner, manager, options) {
        this.owner = owner;
        this.manager = manager;
    }
    show(data) {
        return this.manager.show(this.owner, data);
    }
    close(name, result) {
        this.manager.close(name, result);
    }
    closeAll() { }
    toggle(name, params) { }
    error(options) {
        log('error %o', options);
        options = core_1.hooks.errorModalOptionsHook(options);
        let message = options.message;
        if (!message) {
            const exception = options.error;
            if (isError(exception)) {
                message = exception.message;
            }
            else if (_.isString(exception)) {
                message = exception;
            }
            else {
                console.warn('Handler for this type of error is not implemented!');
                console.error(exception);
                return;
            }
        }
        return this.manager.show(this.owner, {
            name: 'MessageBox',
            maxInstancesPerComponent: 3,
            props: {
                type: 'error',
                header: options.title || 'Error',
                message,
                details: options.details
            }
        });
    }
    async confirm(options) {
        return this.manager
            .show(this.owner, { name: 'ConfirmDialog', props: options })
            .then(result => result.value);
    }
}
exports.ModalService = ModalService;
//# sourceMappingURL=modal-service.js.map